import { EMPTY_AUTH_STATE } from '@/constants';
import { type AuthState, subscribeIam as subscribeAuth } from '@b2x/authentication';
import { LOG_GROUPS, LOG_LEVEL, tryCatch } from '@b2x/shared';
import { logger } from './logger';

function getAuthenticationState(): Promise<AuthState> {
  const timeout = 5000;
  return new Promise((resolve, reject) => {
    let done = false;
    const timeoutId = setTimeout(() => {
      if (!done) {
        done = true;
        reject(new Error(`Failed to retrieve auth connection state within ${timeout}ms`));
      }
    }, timeout);

    subscribeAuth(
      (state) => {
        if (!done) {
          done = true;
          clearTimeout(timeoutId);
          resolve(state);
        }
      },
      { once: true },
    );
  });
}

export async function resolveAuthState(): Promise<AuthState> {
  const { data, error } = await tryCatch(getAuthenticationState());

  if (error) {
    logger('Authentication Error', {
      args: [error.message],
      group: LOG_GROUPS.BOOTSTRAP,
      level: LOG_LEVEL.ERROR,
    });
  }

  return data ?? EMPTY_AUTH_STATE;
}
